import React from 'react';
import { Grid, Box } from '@mui/material';
import InfoCards from './InfoCards';
import useFetchData from './AdminDashboardCharts/useFetchData';
import MostUsedMachinesChart from './AdminDashboardCharts/MostUsedMachinesChart';
import WeeklyStatisticsChart from './AdminDashboardCharts/WeeklyStatisticsChart';
import CostVsUseChart from './AdminDashboardCharts/CostVsUseChart';
import AdminRolesChart from './AdminDashboardCharts/AdminRolesChart';
import KeyProjectsChart from './AdminDashboardCharts/KeyProjectsChart';
import MostIssuedItemsChart from './AdminDashboardCharts/MostIssuedItemsChart';
import MostPurchasedItemsChart from './AdminDashboardCharts/MostPurchasedItemsChart';
import FootfallChart from './AdminDashboardCharts/FootfallChart';
import LiveOccupancy from './AdminDashboardCharts/LiveOccupancy';
import CameraStatsChart from './AdminDashboardCharts/CameraStatsChart';
import TotalVisitorsToday from './AdminDashboardCharts/TotalVisitorsToday';

const Dashboard = () => {
  const {
    mostUsedMachinesData,
    mostIssuedItemsData,
    mostPurchasedItemsData,
    weeklyStatisticsData,
    costVsUseData,
    adminRolesData,
    keyProjectsData,
    stats,
  } = useFetchData();

  return (
    <Box
      sx={{
        width: '100%',
        maxWidth: '100%',
        padding: { xs: '0.5rem', sm: '1rem', md: '1rem' },
        marginTop: '0',
        overflowX: 'hidden',
        boxSizing: 'border-box',
      }}
    >
      <InfoCards stats={stats} />
      <Box sx={{ flexGrow: 1, mb: 3 }}>
        {/* <Grid container spacing={3}>
          <Grid item xs={12} md={6}>
              <CameraStatsChart />
          </Grid>
          <Grid item xs={12} md={6}>
            <TotalVisitorsToday />
          </Grid>
        </Grid> */}
        <Grid container spacing={3}>
          {/* <Grid item xs={12} md={6}>
            <LiveOccupancy />
          </Grid>
          <Grid item xs={12} md={6}>
            <FootfallChart />
          </Grid> */}
          <Grid item xs={12} md={6}>
            <MostUsedMachinesChart data={mostUsedMachinesData} />
          </Grid>
          <Grid item xs={12} md={6}>
            <WeeklyStatisticsChart data={weeklyStatisticsData} />
          </Grid>
          <Grid item xs={12} md={6}>
            <CostVsUseChart data={costVsUseData} />
          </Grid>
          <Grid item xs={12} md={6}>
            <MostIssuedItemsChart data={mostIssuedItemsData} />
          </Grid>
          <Grid item xs={12} md={6}>
            <KeyProjectsChart data={keyProjectsData} />
          </Grid>
          <Grid item xs={12} md={6}>
            <AdminRolesChart data={adminRolesData} />
          </Grid>
          <Grid item xs={12} md={6}>
            <MostPurchasedItemsChart data={mostPurchasedItemsData} />
          </Grid>
        </Grid>
      </Box>
    </Box>
  );
};

export default Dashboard;
